import { dispatchSnackbarNegativeEvent, RouteLeavingGuard } from '@dreryk/react-components';
import { useDraftCreateCqrsCommand } from '@dreryk/react-draft';

import { visitTranslationKeys } from '../../../translations';
import { getDocumentTemplateDraftTag, getVisitDraftTag } from '../../../visit/visit.draft';
import { getReferralDraftToken } from '../referral.draft';
import { referralTranslationKeys } from '../translations';

import { ReferralToRehabilitationFormController } from './ReferralToRehabilitationForm/ReferralToRehabilitationForm.types';

type ReferralToRehabilitationRouteLeavingGuardProps = {
   readonly visitId: number;
   readonly formState: ReferralToRehabilitationFormController['formState'];
   readonly handleSubmitDraft: ReferralToRehabilitationFormController['handleSubmitDraft'];
};

export const ReferralToRehabilitationRouteLeavingGuard = (
   props: ReferralToRehabilitationRouteLeavingGuardProps
): JSX.Element => {
   const { executeAsync: saveReferralToRehabilitationDraft } = useDraftCreateCqrsCommand({
      onUnexpectedError: () => {
         dispatchSnackbarNegativeEvent(visitTranslationKeys.draftSaveFail);
      },
   });
   return (
      <RouteLeavingGuard
         testId={'referralToRehabilitation'}
         active={props.formState.isDirty}
         onLeave={props.handleSubmitDraft(async (values) =>
            saveReferralToRehabilitationDraft({
               token: getReferralDraftToken('referralToRehabilitation', props.visitId),
               tags: [getVisitDraftTag(props.visitId), getDocumentTemplateDraftTag(props.visitId)],
               contents: values,
            })
         )}
         successMessage={referralTranslationKeys.referralDraftSaved}
      />
   );
};
